<template>
  <div class="row" v-if="canRead">
    <div class="col-md-12">
      <card style="padding: 10px;">
        <button type="button" v-if="canEdit" @click="uploadForm" class="btn btn-fill btn-info" style="float: right; margin-top: -4px;">
          Upload Form(s)
        </button>
        <tabs ref="filesTabs" value="Files" tab-content-classes="text-center">
          <tab-pane title="Inspection Forms" key="inspectionForms" id="inspection-forms">
            <inspection-forms></inspection-forms>
          </tab-pane>
          <tab-pane title="Floor Plans" key="floorPlans" id="floor-plans">
            <floor-plans></floor-plans>
          </tab-pane>
          <tab-pane title="Energy Plans" key="energyPlans" id="energy-plans">
            <energy-plans></energy-plans>
          </tab-pane>
        </tabs>
      </card>
    </div>
  </div>
</template>
<script>
  import Permissions from 'src/utilities/permissions'
  import {Tabs, TabPane, Card} from 'src/components/UIComponents'
  import InspectionForms from './InspectionForms'
  import FloorPlans from './FloorPlans'
  import EnergyPlans from './EnergyPlans'

  export default {
    components: {
      Card,
      InspectionForms,
      FloorPlans,
      EnergyPlans,
      Tabs,
      TabPane
    },
    methods: {
      uploadForm() {
        let activeTab
        this.$refs.filesTabs.tabs.forEach(tab => {
          if (tab.active) {
            activeTab = tab.id
          }
        })

        this.$eventHub.$emit('show-modal-1', 'Upload Forms', {folder: activeTab}, '500px')
      },
    },
    computed: {
      canRead() {
        return this.$can('read', Permissions.FILES)
      },
      canEdit() {
        return this.$can('edit', Permissions.FILES)
      }
    }
  }
</script>
<style scoped>

</style>
